import { Button, Form, Input, notification, theme, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../../../assets";
import "../../../config/globals.css";
import { useAuth } from "../../../providers";
import { WelcomeRoute } from "../../welcome";

export const LoginView = () => {
  const [api, contextHolder] = notification.useNotification()
  const [form] = Form.useForm();
  const { login } = useAuth();
  const [isLoadingLogin, setisLoadingLogin] = useState(false);
  const navigate = useNavigate();
  const {
    token: { colorPrimary },
  } = theme.useToken();

  const handleLogin = async () => {
    setisLoadingLogin(true);
    try {
      const values = await form.validateFields();

      await login({ email: values.email, password: values.password })
        .then((response) => {
          if (response) {
            navigate(WelcomeRoute);
          } else {
            api.warning({
              message: "Usuario y/o contraseña incorrectos",
              description: "Por favor, verifica la información.",
              placement: "top",
              className: "custom-general-notification-bg",
              duration: 3,
            });
          }
        });
      setisLoadingLogin(false);
    } catch (error) {
      console.error("Error en la validación:", error);
    }
  };

  return (
    <>
      {contextHolder}
      <div
        style={{
          height: "100vh",
          width: "100%",
          backgroundImage: `url(/agenteia-5.webp)`, // Imagen de fondo
          backgroundSize: "130%",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        {/* Capa de superposición con el color primario del tema */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: `${colorPrimary}F2`,
            zIndex: 1,
          }}
        />

        {/* Formulario centrado */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "white",
            padding: "32px",
            borderRadius: "16px",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
            zIndex: 2,
            width: "100%",
            maxWidth: "400px", // Ancho máximo del formulario
          }}
        >
          <Logo height={150} width={150} style={{ display: "block", margin: "0 auto" }} />
          <Typography.Title
            level={2}
            style={{ fontWeight: "bold", textAlign: "center", marginBottom: 12 }}
          >
            Iniciar Sesión
          </Typography.Title>
          <Typography.Text
            style={{
              display: "block",
              textAlign: "center",
              color: "gray",
              marginBottom: 16,
            }}
          >
            Accede a tu cuenta para gestionar tus casos de uso
          </Typography.Text>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleLogin}
            style={{ width: "100%" }}
          >
            <Form.Item
              label="Correo"
              name="email"
              rules={[
                { required: true, message: "Por favor ingresa tu correo" },
                { type: "email", message: "Ingresa un correo válido" },
              ]}
            >
              <Input size="large" placeholder="correo@ejemplo.com" />
            </Form.Item>
            <Form.Item
              label="Contraseña"
              name="password"
              rules={[{ required: true, message: "Por favor ingresa tu contraseña" }]}
            >
              <Input.Password size="large" placeholder="Contraseña" />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                style={{ width: "100%" }}
                loading={isLoadingLogin}
              >
                Iniciar Sesión
              </Button>
            </Form.Item>
          </Form>
          <div style={{ textAlign: "center", marginTop: 10 }}>
            <Typography.Text type="secondary">
              ¿Solo quieres explorar?{" "}
              <Typography.Link
                href="/#/"
                style={{
                  fontWeight: "bold",
                  fontSize: 15,
                  color: "#1677ff",
                  transition: "color 0.2s",
                }}
              >
                Acceso sin cuenta
              </Typography.Link>
            </Typography.Text>
          </div>
        </div>
      </div>
    </>
  );
};

export const LoginRoute = "/auth/login";
